<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header color="#E7F2F8">
                            <template v-slot:default="{ open }">
                                <v-row no-gutters>
                                    <v-col cols="4">Select Course&#40;s&#41;</v-col>
                                    <v-col cols="8" class="text--secondary">
                                        <v-fade-transition leave-absolute>
                                            <span v-if="open" key="0">
                                                Search from the timetable below and click +
                                            </span>
                                            <span v-else key="1">
                                                <v-simple-table style="width: 100%; border: none;" dense v-if="selectedCourses.length > 0">
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th>Discipline</th>
                                                                <th>Subject</th>
                                                                <th>Section</th>
                                                                <th>Class #</th>
                                                                <th>Catalog</th>
                                                                <th>Instructor</th>
                                                                <th>Component</th>
                                                                <th>Session</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="course in selectedCourses" :key="course.classnbr">
                                                                <td>{{ course.subject }}</td>
                                                                <td>{{ course["subject-resolved"] }}</td>
                                                                <td>{{ course.classsection }}</td>
                                                                <td>{{ course.classnbr }}</td>
                                                                <td>{{ course.catalognbr }}</td>
                                                                <td><v-chip color="#D3B5E5" v-if="course.instructorname.length>0">{{ course.instructorname }}</v-chip></td>
                                                                <td><v-chip color="#98D7C2" v-if="course.ssrcomponent == 'LEC'">{{ course.ssrcomponent }}</v-chip><span v-else>{{ course.ssrcomponent }}</span></td>
                                                                <td>{{ course.sessioncode }}</td>
                                                                <td><v-icon small class="mr-2" @click="deleteCourse(course)" color="#EF7C8E">mdi-trash-can</v-icon></td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </span>
                                        </v-fade-transition>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content color="F8FAFD">
                            <v-card elevation="0">
                                <v-card-text>
                                    <v-simple-table style="width: 100%; border: none;" dense>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Discipline</th>
                                                    <th>Subject</th>
                                                    <th>Section</th>
                                                    <th>Class Format</th>
                                                    <th>Class #</th>
                                                    <th>Catalog</th>
                                                    <th>Instructor</th>
                                                    <th>Time</th>
                                                    <th>Component</th>
                                                    <th>Session</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="course in selectedCourses" :key="course.classnbr">
                                                    <td>{{ course.subject }}</td>
                                                    <td>{{ course["subject-resolved"] }}</td>
                                                    <td>{{ course.classsection }}</td>
                                                    <td>{{ course.classformat }}</td>
                                                    <td>{{ course.classnbr }}</td>
                                                    <td>{{ course.catalognbr }}</td>
                                                    <td><v-chip color="#D3B5E5" v-if="course.instructorname.length>0">{{ course.instructorname }}</v-chip></td>
                                                    <td>{{ course.starttime }}-{{ course.endtime }}</td>
                                                    <td><v-chip color="#98D7C2" v-if="course.ssrcomponent == 'LEC'">{{ course.ssrcomponent }}</v-chip><span v-else>{{ course.ssrcomponent }}</span></td>
                                                    <td>{{ course.sessioncode }}</td>
                                                    <td><v-icon small class="mr-2" @click="deleteCourse(course)" color="#EF7C8E">mdi-trash-can</v-icon></td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table><br />
                                    <v-data-table
                                        :headers="headers"
                                        :items="timetable"
                                        :search="search"
                                        :loading="timetableloading"
                                        loading-text="Loading Timetable..."
                                        :items-per-page="5"
                                        class="elevation-0"
                                        dense
                                    >
                                        <template v-slot:top>
                                            <v-row>
                                                <v-col cols="7">
                                                    <v-card-text style="width: 100%;">
                                                        <v-text-field
                                                            v-model="search"
                                                            append-icon="mdi-magnify"
                                                            label="Search"
                                                            single-line
                                                            hide-details
                                                        ></v-text-field>
                                                    </v-card-text>
                                                </v-col>
                                                <v-col cols="5">
                                                    <v-card-subtitle style="width:100%; text-align:right;">
                                                        <i>Timetable last uploaded on <b>{{ uploadeddate }}</b></i>
                                                    </v-card-subtitle>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <template v-slot:item.mon="{ item }">
                                            <v-checkbox
                                                v-model="item.mon"
                                                disabled
                                                true-value="Mon"
                                                dense
                                            ></v-checkbox>
                                        </template>
                                        <template v-slot:item.tues="{ item }">
                                            <v-checkbox
                                                v-model="item.tues"
                                                disabled
                                                true-value="Tue"
                                                dense
                                            ></v-checkbox>
                                        </template>
                                        <template v-slot:item.wed="{ item }">
                                            <v-checkbox
                                                v-model="item.wed"
                                                disabled
                                                true-value="Wed"
                                                dense
                                            ></v-checkbox>
                                        </template>
                                        <template v-slot:item.thurs="{ item }">
                                            <v-checkbox
                                                v-model="item.thurs"
                                                disabled
                                                true-value="Thu"
                                                dense
                                            ></v-checkbox>
                                        </template>
                                        <template v-slot:item.fri="{ item }">
                                            <v-checkbox
                                                v-model="item.fri"
                                                disabled
                                                true-value="Fri"
                                                dense
                                            ></v-checkbox>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                            <v-btn icon class="mr-2" @click="addCourse(item)" color="#29A0B1" small :loading="addbtnLoading"><v-icon>mdi-plus-thick</v-icon></v-btn>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <br />
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="postingTitle"
                            label="Discipline"
                            prepend-icon="mdi-file-document-outline"
                            @keydown="validatebtn"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-textarea
                            outlined
                            label="Qualifications"
                            v-model="qualification"
                            height="250px"
                            @keydown="validatebtn"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-textarea
                            outlined
                            label="Additional Notes"
                            v-model="notes"
                            height="250px"
                            @keydown="validatebtn"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-menu
                            v-model="menustart"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="postingstartdate"
                                    label="Posting Start Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="postingstartdate"
                                :show-current="today"
                                @input="validateStart"
                                color="#189AB4"
                                no-title
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-menu
                            v-model="menuend"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="postingenddate"
                                    label="Posting End Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="postingenddate"
                                :show-current="postingstartdate"
                                @input="validateEnd"
                                no-title
                                color="#189AB4"
                                :allowed-dates="validateEndDate"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="salary" prefix="$"
                            label="Salary"
                            prepend-icon="mdi-cash-multiple"
                            @keydown="validatebtn"
                            v-if="cluster"
                        ></v-text-field>
                        <v-simple-table style="width: 100%; border-collapse: collapse;" v-else>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Effective Date as of May 1</th>
                                        <th>0.5 Course Load</th>
                                        <th>1.0 Course Load</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in courseSalary" :key="item">
                                        <td>{{ item.year }}</td>
                                        <td>${{ item.halfcourse }}</td>
                                        <td>${{ item.fullcourse }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row justify="end" align="end">
                    <v-col cols="3" style="text-align: right;">
                        <v-btn color="#60A3D9" @click="editPosting" :loading="submitloading" :disabled="disablesubmitbtn">
                            Update Posting
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-dialog v-model="dialogAddCourse" width="850px" persistent>
                <v-card>
                    <v-toolbar color="#E7F2F8" elevation="0">
                        <v-toolbar-title>Add Course</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeaddCourseDialog"><v-icon>mdi-close</v-icon></v-btn>
                    </v-toolbar><br />
                    <v-card-text style="text-align: center;">
                        <v-container style="height: 200px;" v-if="addbtnLoading">
                            <v-row
                                class="fill-height"
                                align-content="center"
                                justify="center"
                            >
                                <v-col
                                    class="text-subtitle-1 text-center"
                                    cols="12"
                                >
                                    <v-progress-linear
                                        color="#E7F2F8"
                                        indeterminate
                                        rounded
                                    ></v-progress-linear>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-simple-table style="width: 100%; border: none;" v-else>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Discipline</th>
                                        <th>Section</th>
                                        <th>Class Format</th>
                                        <th>Class #</th>
                                        <th>Catalog</th>
                                        <th>Instructor</th>
                                        <th>Component</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="course in selectedCourseforclassformat" :key="course.classnbr">
                                        <td>{{ course.subject }}</td>
                                        <td>{{ course.classsection }}</td>
                                        <td><v-select outlined v-model="course.classformat" :items="classformatitems" dense hide-details></v-select></td>
                                        <td>{{ course.classnbr }}</td>
                                        <td>{{ course.catalognbr }}</td>
                                        <td>{{ course.instructorname }}</td>
                                        <td>{{ course.ssrcomponent }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                    <v-snackbar
                        v-model="snackbar2"
                        :color="snackbarcolor2"
                        :timeout="timeout2"
                        :multi-line="true"
                        top
                    >
                        {{ text2 }}
                    </v-snackbar>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark color="#05445E" @click="decideClassFormat()">Add Course&#40;s&#41; to Posting</v-btn>
                    </v-card-actions>
                    <br />
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogWarning" max-width="580px" persistent>
                <v-card><br />
                    <v-card-text style="text-align: center;">
                        <v-row justify="center" align="center">
                            <v-col cols="12">
                                <v-alert type="warning" prominent border="left">{{ dialogText }}</v-alert>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="#05445E" @click="dialogWarning = false">OK</v-btn>
                    </v-card-actions>
                    <br />
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogdeleteWarning" max-width="580px" persistent>
                <v-card><br />
                    <v-card-text style="text-align: center; color: black;"><br />
                        <v-row justify="center" align="center">
                            <v-col cols="10">
                                This is a <b>{{ selecteddeleteCourse.ssrcomponent }}</b> record that is potentially linked to a lecture. <br /><br />
                                Upon removal, only this record will be removed. Are you sure to continue?
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="#05445E" @click="dialogdeleteWarning = false">No</v-btn>
                        <v-btn text color="#05445E" @click="deselectCourse(selecteddeleteCourse)">Yes</v-btn>
                    </v-card-actions>
                    <br />
                </v-card>
            </v-dialog>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        item : {
            required: true
        }
    },
    data(){
        return {
            host: location.hostname.toString(),
            today: "",
            sessioncoderesolution: [],
            snackbar: false,
            snackbar2: false,
            snackbarcolor: "",
            snackbarcolor2: "",
            text: "",
            text2: "",
            timeout: 3500,
            timeout2: 4000,
            timetableloading: false,
            search: "",
            expanded: [],
            headers: [
                {text: "Source" , value: "source"},
                {text: "Stream" , value: "strm"},
                {text: "Discipline" , value: "subject-resolved"},
                {text: "Section" , value: "classsection"},
                {text: "Catalog" , value: "catalognbr"},
                {text: "Class #" , value: "classnbr"},
                {text: "Component", value: "ssrcomponent"},
                {text: "Instructor" , value: "instructorname"},
                {text: "Mon", value: "mon"},
                {text: "Tue", value: "tues"},
                {text: "Wed", value: "wed"},
                {text: "Thu", value: "thurs"},
                {text: "Fri", value: "fri"},
                {text: "Session", value: "sessioncode"},
                {text: "Add", value: "action", sortable: false}
            ],
            timetable: [],
            uploadeddate: "",
            selectedCourses: [],
            selecteddeleteCourse: {},
            postingTitle: "",
            qualification: "",
            notes: "",
            menustart: false,
            menuend: false,
            postingstartdate: "",
            postingenddate: "",
            menuinstructionstart: false,
            menuinstructionend: false,
            salary: "",
            courseSalary: [],
            dialogWarning: false,
            dialogText: "",
            dialogdeleteWarning: false,
            disablesubmitbtn: true,
            submitloading: false,
            addbtnLoading: false,
            cluster: false,
            classformatitems: ["In-person", "Online Asynchronous", "Online Synchronous", "Blended"],
            dialogAddCourse: false,
            selectedCourseforclassformat: [],
            selectedClassFormat: "",
            department: ""
        }
    },
    methods: {
        initializeValue(){
            const that = this;

            that.selectedCourses = that.item.courses;
            that.postingTitle = that.item.title;
            that.qualification = that.item.qualifications;
            that.notes = that.item.notes;
            that.postingstartdate = that.item.startDate;
            that.postingenddate = that.item.endDate;
            if(that.item.type == "CLUSTER") {
                that.cluster = true;
                that.salary = that.item.salary;
            }else {
                that.cluster = false;
                that.courseSalary = that.item.salary;
            }

            that.department = that.item.department;
        },
        getSalaryInfo(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getFormControl&data={"type": "salary"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            if(that.courseSalary.length == 0){
                                that.courseSalary = json.data[0]["config"]["grid"];
                            }
                        }
                    }
                })
                .catch(function () {
                })
        },
        getSessionCodeResolution(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getFormControl&data={"type":"instructiondates"}';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            that.sessioncoderesolution = json.data[0].config.dates;
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        getDate(){
            const that = this;
            let date = new Date().toISOString().slice(0, 10);

            that.today = date;
        },
        showtimetable(){
            const that = this;
            that.timetableloading = true;
            that.timetable = [];

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=timetableSearch';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        resultData.data.forEach(element => {
                            if(element.hasOwnProperty('system')){
                                that.translateTimestamp(element["timestamp"]);
                            }else {
                                that.timetable.push(element);
                            }
                        });
                    }
                    that.timetableloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        translateTimestamp(timestamp){
            const that = this;

            var date = new Date(parseInt(timestamp));

            that.uploadeddate = date.toDateString();
        },
        splitMeetingTime(meetingtime){
            return meetingtime.split(" ")[1]
        },
        resolveGeneralTerm(strm){
            const that = this;
            let term = strm.slice(-1);
            if(term == "9"){
                var year = strm[1]+strm[2];
                var year2 = (parseInt(year)+1).toString();
                var century = (parseInt(strm[0])-1).toString();
                return "FALL2"+century+year+"/WINTER2"+century+year2;
            }else if(term == "5"){
                return "SUMMER";
            }
        },
        decideClassFormat(){
            const that = this;
            var passList = [];
            for(var i=0;i<that.selectedCourseforclassformat.length;i++){
                that.selectedCourseforclassformat[i]["academicterm"] = that.resolveGeneralTerm(that.selectedCourseforclassformat[i]["strm"]);
                if(that.selectedCourseforclassformat[i]["classformat"] != "" ){
                    passList.push(that.selectedCourseforclassformat[i]);
                }else {
                    that.text2 = "Please select a Class Format for "+that.selectedCourseforclassformat[i]["ssrcomponent"]+" component";
                    that.snackbar2 = true;
                    that.snackbarcolor2="#EF6C00";
                }
            }

            if(parseInt(that.selectedCourseforclassformat.length) == parseInt(passList.length)){
                passList.forEach(element => {
                    that.selectedCourses.push(element);
                });
                
                that.resolvePostingType();
                that.validatebtn();

                that.dialogAddCourse = false;
                that.selectedCourseforclassformat = [];
            }else {
                passList = [];
            }
        },
        closeaddCourseDialog(){
            const that = this;
            that.dialogAddCourse = false;
            that.selectedCourseforclassformat = [];
        },
        addCourse(item){
            const that = this;
            let array=[];
            that.selectedCourses.forEach(element => {
                array.push(element["id"]);
            });
            if(that.selectedCourses.length > 0){
                if(item["subject"].toLowerCase() == that.selectedCourses[0]["subject"].toLowerCase()){

                    if(array.includes(item["id"])){
                        that.dialogText = "This record is already added.";
                        that.dialogWarning = true;
                        
                        that.resolvePostingType();
                        that.validatebtn();
                    }else {
                        item["classformat"] = "";
                        that.dialogAddCourse = true;

                        if(item.ssrcomponent == "LEC"){
                            that.selectedCourseforclassformat.push(item);
                            that.timetableSearch(item);
                        }else {
                            that.selectedCourseforclassformat.push(item);
                        }
                    }

                }else {
                    that.dialogText = "Posting must be made within the same discipline.";
                    that.dialogWarning = true;
                    
                    that.resolvePostingType();
                    that.validatebtn();
                }
            }else {
                item["classformat"] = "";
                that.dialogAddCourse = true;

                if(item.ssrcomponent == "LEC"){
                    that.selectedCourseforclassformat.push(item);
                    that.timetableSearch(item);
                    that.department = that.item["academicdepartment"];
                }else {
                    that.selectedCourseforclassformat.push(item);
                }
            }
        },
        timetableSearch(item){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=timetableSearch&data={"subject":"'+item.subject+'", "catalognbr":"'+item.catalognbr+'", "associatedclass":"'+item.associatedclass+'"}';
            that.addbtnLoading = true;
            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        resultData.data.forEach(element => {
                            if(element.hasOwnProperty('components')){
                                if(element["components"].length > 0){
                                    element["components"].forEach(e => {
                                        e["classformat"] = "";
                                        that.selectedCourseforclassformat.push(e);
                                    });
                                }else {
                                    that.text2 = "Note: No tutorials nor labs were found for "+element["subject"]+" "+element["catalognbr"]+" - "+element["classsection"]+". "
                                                +"Tutorials/Labs are resolved by matching catalog number, associated class and subject information.";
                                    that.snackbar2 = true;
                                    that.snackbarcolor2="#04D4F0";
                                }
                            }
                        });
                    }
                    that.addbtnLoading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        deleteCourse(item){
            const that = this;
            if(item["ssrcomponent"] == "LEC"){
                that.deselectCourse(item);
            }else {
                that.selecteddeleteCourse = item;
                that.dialogdeleteWarning = true;
            }

            that.resolvePostingType();
        },
        deselectCourse(item){
            const that = this;
            let deletedArray = [];
            if(item["ssrcomponent"] == "LEC"){
                that.selectedCourses.forEach(element => {
                    if(!(element["catalognbr"] == item["catalognbr"] && element["subject"] == item["subject"] && element["associatedclass"] == item["associatedclass"])){
                        deletedArray.push(element);
                    }
                });
            }else {
                that.selectedCourses.forEach(element => {
                    if(element["classnbr"] != item["classnbr"]){
                        deletedArray.push(element);
                    }
                });
            }

            that.selectedCourses = deletedArray;
            that.dialogdeleteWarning = false;
            that.validatebtn();
        },
        validateStart(){
            const that = this;

            that.menustart = false;
            that.validatebtn();
        },
        validateEnd(){
            const that = this;

            that.menuend = false;
            that.validatebtn();
        },
        validateEndDate(val){
            const that = this;

            return val >= that.postingstartdate
        },
        validatebtn(){
            const that = this;
            if(that.selectedCourses.length > 0 && that.qualification.length>0 && that.postingstartdate.length>0 && that.postingenddate.length>0){
                that.disablesubmitbtn = false;
            }else {
                that.disablesubmitbtn = true;
            }
        },
        resolveSessionCode(){
            const that = this;

            that.selectedCourses.forEach(element => {
                that.sessioncoderesolution.forEach(codes => {
                    if(element["sessioncode"] == codes["code"]){
                        element["instructionstart"] = codes["startdate"];
                        element["instructionend"] = codes["enddate"];
                    }
                });
            });
        },
        resolvePostingType(){
            const that = this;
            var leccount = 0;
            that.selectedCourses.forEach(element => {
                if(element["ssrcomponent"] == "LEC"){
                    leccount = leccount + 1;
                }
            });

            if(leccount > 1){
                that.cluster = true;
            }else {
                that.cluster = false;
            }
        },
        editPosting(){
            const that = this;
            let api= 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            that.submitloading = true;

            that.resolveSessionCode();
            var savesalary = "";
            //Cluster Posting resolution
            let postingtype = "";
            var leccount = 0;
            that.selectedCourses.forEach(element => {
                if(element["ssrcomponent"] == "LEC"){
                    leccount = leccount + 1;
                }
            });

            if(leccount > 1){
                postingtype = "CLUSTER";
                savesalary = that.salary;
            }else {
                postingtype = "COURSE";
                savesalary = that.courseSalary;
            }
            //End of cluster posting resolution

            var postinginfo = {
                id: that.item.id,
                title: that.postingTitle,
                discipline: that.selectedCourses[0]["subject"],
                strm: that.selectedCourses[0]["strm"],
                courses: that.selectedCourses,
                startDate: that.postingstartdate,
                endDate: that.postingenddate,
                qualifications: that.qualification,
                notes: that.notes,
                type: postingtype,
                salary: savesalary
            };

            const formData = new FormData();
            formData.append("mode", "postingWrite");
            formData.append("data", JSON.stringify(postinginfo));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Posting successfully modified", "green");
                    that.submitloading = false;
                    that.disablesubmitbtn = true;
                    
                    
                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    that.submitloading = false;
                    that.disablesubmitbtn = true;
                }
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red")
                that.submitloading = false;
                that.disablesubmitbtn = true;
            })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this; 
        that.showtimetable();
        that.getDate();
        that.initializeValue();
        that.getSessionCodeResolution();
        that.getSalaryInfo();
    }
}
</script>